module.exports = __webpack_public_path__ + "static/3-893517b767bd275288548b1c44bd21b5.jpg";